module.exports = __webpack_public_path__ + "media/images/countryrect/kr-99a25e15fdac58b7410c924ddff62013.svg";